import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Button } from '@mui/material';

const FailurePayment = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const redirectTimeout = setTimeout(() => {
            navigate('/'); // Assuming you want to redirect to the homepage or a specific page after a delay
        }, 5000);

        return () => clearTimeout(redirectTimeout);
    }, [navigate]);

    const handleRetry = () => {
        navigate('/souscriptions'); // Modify this to the path where the user can attempt to pay again
    };

    return (
        <Container component="main" maxWidth="xs">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Typography component="h1" variant="h5">
                    Échec du paiement
                </Typography>
                <Typography component="p" variant="body1" style={{ marginTop: '16px', marginBottom: '16px' }}>
                    Nous sommes désolés, mais nous n'avons pas pu traiter votre paiement.
                </Typography>
                <Typography component="p" variant="body2" style={{ marginTop: '16px' }}>
                    Vous serez redirigé vers la page d'accueil...
                </Typography>
            </div>
        </Container>
    );
};

export default FailurePayment;
